export const ReferentEnvironment = {
    production: false,
    baseUrl: 'https://eovlastenjatst.fina.hr/webapi',
    niasRedirectUrl: 'http://localhost:4200/nias-auth',
    niasRedirectErrorUrl: 'http://localhost:4200/nias-error',
    niasLogoutUrl: 'http://localhost:4200/nias-logout'
}